import type { PayPalScriptOptions } from '@paypal/paypal-js';
import { Preferences } from '@interfaces/models/preferences';

export class PayPalOSMService {
  static isEligible({ currency, country }: Partial<Preferences>): boolean {
    const posibilities = {
      GB: ['GBP'],
      FR: ['EUR'],
      DE: ['EUR'],
      US: ['USD'],
      AU: ['AUD'],
      IT: ['EUR'],
      ES: ['EUR'],
    };
    return (posibilities[country] || []).includes(currency);
  }

  static getConfigs(): PayPalScriptOptions {
    return {
      'client-id': 'ATPXUSefOrXC2_fjG8XFSlHET7W-jJXQ1R_5gFy5yrwTEBUMAbmYfp5xsirZd_y6btZ9ONbwJeTGdmQt',
      components: 'messages',
    };
  }
}

export default {};
